import printDepositPackingComponent from './print_deposit_packing.component';

let printDepositPackingModule = angular.module('printDepositPacking', [
	])
	.config(($stateProvider, $urlRouterProvider) => {
		"ngInject";

		$urlRouterProvider.otherwise('/deposit-packing');

		$stateProvider
			.state('printDepositPacking', {
				url: '/print-deposit-packing',
				component: 'printDepositPacking',
				data: {
					requireLogin: true,
					requireACL: 'deposit_packing.all'	
				},
			});
	})

	.component('printDepositPacking', printDepositPackingComponent)

	.name;

export default printDepositPackingModule;




// WEBPACK FOOTER //
// ./client/app/components/deposit_packing/print/index.js